import React from 'react';
import PropTypes from 'prop-types';

// Shared Components
import styles from './EntityNameLabel.scss';

export default function EntityNameLabel({ name, description }) {
  return (
    <div className={styles.entityNameLabel}>
      <div className={styles.entityName}>{name}</div>
      <div className={styles.entityDescription}>{description}</div>
    </div>
  );
}

EntityNameLabel.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
};
